module.exports = __webpack_public_path__ + "img/admin-2017-postdoc.2c54531f.jpg";